import { memo } from "react";
import { Controller, FieldValues } from "react-hook-form";
import { InputControllerProps } from './types';
import { TextField } from '@mui/material';
import { Group } from './styles';


const InputTextComponent = <F extends FieldValues>(props: InputControllerProps<F>) => {
	const {
		control,
		label,
		name,
		placeholder,
		onChangeCallback,
		rules,
		type,
		id,
		variant = "outlined",
		sx,
		inputRef
	} = props
	const currentId = id ?? name
	return (
		<Group>
			<Controller
				name={name}
				control={control}
				rules={rules}
				render={({ field: { value, onChange, name }, fieldState: { error } }) => {
					const errorMessage =
						error?.type === "required"
							? "This is required field"
							: error?.message;
					return (
						<TextField
							name={name}
							type={type}
							id={currentId}
							value={value || ''}
							variant={variant}
							placeholder={placeholder ?? label}
							error={!!error}
							sx={{'& legend': { display: 'none' },
								'& fieldset': { top: 0 }}}
							helperText={errorMessage ? errorMessage : null}
							onChange={onChangeCallback ?? onChange}
							ref={inputRef}
						/>
					);
				}}
			/>
		</Group>
	);
};

export const TextInput = memo(
	InputTextComponent
) as typeof InputTextComponent;
